import { fetch_sadap } from "../../core/api"

export function getAllEmployee(page){
    const path ="employee-biodata/employee?page="+page
    return fetch_sadap(path,"get",{},false);
}

export function getEmployeeById(data){
    const path ="employee-biodata/employee/detail"
    return fetch_sadap(path,"post",data,false);
}

export function updateEmployeeById(data){
    const path ="employee-biodata/employee/update"
    return fetch_sadap(path,"put",data,false);
}

export function checkPassword(data){
    const path ="auth/user/password/check"
    return fetch_sadap(path,"post",data,false);
}

export function changePassword(data){
    const path ="auth/user/password"
    return fetch_sadap(path,"put",data,false);
}

export function getEmployeeByName(name){
    const path ="employee-biodata/employee/list?name="+name
    return fetch_sadap(path,"get",{},false);
}